<template>
  <div class='asset-sensitivity' :class='sensitivity' @click.stop='openSensitivityPopup()'>
    {{ sensitivityText }}
  </div>
</template>

<script>
export default {
  name: 'AssetSensitivity',
  props: {
    sensitivity: {
      type: String,
      required: true,
    },
  },
  computed: {
    sensitivityText() {
      return this.$t(`asset.sensitivity.${this.sensitivity}`);
    },
  },
  methods: {
    openSensitivityPopup() {
      this.$emit('openSensitivityPopup');
    },
  },
};
</script>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';

.asset-sensitivity {
  border-radius: $radius-sm;
  padding: rem(3) $space-2;
  width: rem(75);
  text-align: center;
  text-transform: capitalize;
  &.high {
    color: $severity-critical;
    background-color: $severity-critical-bg;
  }
  &.medium {
    color: $severity-medium;
    background-color: $severity-medium-bg;
  }
  &.low {
    color: $severity-low;
    background-color: $severity-low-bg;
  }
  &:hover {
    cursor: pointer;
  }
}
</style>
